import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HI: "Hei",
      RIGHT_NOW_WE_ARE_WORKING:
        "Akkurat nå jobber vi med å oppdatere tjenesten vår. Den vil være tilgjengelig igjen i løpet av 5-10 minutter.",
      WE_APOLOGIZE_FOR_THE_INCONVENIENCE:
        "Vi beklager ulempene dette måtte medføre og takker for din forståelse.",
      IF_YOU_HAVE_QUESTIONS: "Hvis du har spørsmål kan du kontakte",
      CUSTOMER_SERVICE_HERE: "kundeservice her",
    },
    se: {
      HI: "Hej",
      RIGHT_NOW_WE_ARE_WORKING:
        "Just nu arbetar vi med att uppdatera vår tjänst. Den kommer att vara tillgänglig igen inom 5-10 minuter.",
      WE_APOLOGIZE_FOR_THE_INCONVENIENCE:
        "Vi ber om ursäkt för de besvär detta kan orsaka och tackar för din förståelse.",
      IF_YOU_HAVE_QUESTIONS: "Om du har frågor kan du kontakta",
      CUSTOMER_SERVICE_HERE: "kundtjänst här",
    },
    dk: {
      HI: "Hej",
      RIGHT_NOW_WE_ARE_WORKING:
        "Lige nu arbejder vi på at opdatere vores service. Den vil være tilgængelig igen inden for 5-10 minutter.",
      WE_APOLOGIZE_FOR_THE_INCONVENIENCE:
        "Vi beklager de ulemper, dette måtte medføre, og takker for din forståelse.",
      IF_YOU_HAVE_QUESTIONS: "Hvis du har spørgsmål, kan du kontakte",
      CUSTOMER_SERVICE_HERE: "kundeservice her",
    },
  } as const
)[language];
